import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./DawgLegalPage.css";

function DawgLegalPage({ content, appName, pageLabel }) {
  return (
    <section className="legal-page">
      <div className="container legal-page-container">
        <div className="legal-app-header">
          <span className="legal-app-name">{appName}</span>
          <span className="legal-app-divider">·</span>
          <span className="legal-page-label">{pageLabel}</span>
        </div>

        <article className="legal-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </article>
      </div>
    </section>
  );
}

export default DawgLegalPage;
